import "./CosmicDiscoveries.module.css";
import React, { useState } from "react";
import Header from "@/reusable_sections/Header";
import Footer from "@/reusable_sections/Footer";
import { CosmicBackground } from "@/components/cosmic/CosmicBackground";
import DiscoveriesIntro from "./sections/DiscoveriesIntro";
import SearchCategories from "./sections/SearchCategories";
import ArticleGrid from "./sections/ArticleGrid";
export default function CosmicDiscoveriesPage() {
  const [searchQuery, setSearchQuery] = useState("");
  const [activeCategory, setActiveCategory] = useState("all");
  return <div className="relative min-h-[100svh] w-full max-w-full overflow-x-clip bg-background text-foreground selection:bg-primary/20 selection:text-primary">
      {/* Shared Cosmic Background fixed behind the page */}
      <CosmicBackground fixed accent="cyan" density={1} />

      {/* Main page content layer */}
      <div className="relative z-10 flex min-h-[100svh] w-full max-w-full flex-col">
        <Header />
        <main className="flex-1">
          <DiscoveriesIntro />
          <SearchCategories searchQuery={searchQuery} onSearchChange={setSearchQuery} activeCategory={activeCategory} onCategoryChange={setActiveCategory} />
          <ArticleGrid searchQuery={searchQuery} activeCategory={activeCategory} onResetFilters={() => {
          setSearchQuery("");
          setActiveCategory("all");
        }} />
        </main>
        <Footer />
      </div>
    </div>;
}